import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, Input,
  OnChanges, OnInit, SimpleChanges, ViewChild
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, UntypedFormControl, AbstractControl, AsyncValidatorFn } from '@angular/forms';
import * as _ from 'lodash';

import * as utils from 'utils/utils';
import { defaultOption, createOption } from 'shared/form/select/option-helpers';
import { Option } from 'shared/form/select/option.interface';
import { Fitment } from './fitment.model';
import { TableComponent } from 'shared/table/table/table.component';


@Component({
  moduleId: module.id,
  selector: 'fitment-edit-form',
  templateUrl: 'fitment-edit-form.component.html',
  styleUrls: ['fitment-edit-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FitmentEditFormComponent extends TableComponent implements OnChanges, OnInit {
  form: UntypedFormGroup;

  @Input() declare data: any;
  @Input() bulkEdit: boolean = false;
  @Input() declare segmentData: any;
  @Input() searchResultsColumns: Array<any>;
  @Input() columnsData: any;
  @Input() itemDetail: any;
  @Input() positionsLookup: any;

  perCarQuantityOptions: Array<Option> = [];

  get isDirty(): boolean {
    return this.form ? this.form.dirty : false;
  }

  get notes(): UntypedFormArray {
    return this.form.get('notes') as UntypedFormArray;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      this.setData(changes.data.currentValue);
      this.ref.markForCheck();
    }
    if (changes.positionsLookup) {
      this.setPositionLookups(changes.positionsLookup.currentValue);
      _.defer(() => this.ref.markForCheck());
    }
  }

  ngOnInit() {
    this.perCarQuantityOptions = _.map(_.range(1, 101), (num: number) => {
      return createOption(num);
    });
    this.createForm();
  }

  // handlers

  onDeleteControlClick(index: number) {
    this.notes.removeAt(index);
    _.defer(() => this.form.markAsDirty());
  }

  onAddAnotherClick() {
    this.notes.push(
      this.getNotesFormGroup({value: ''})
    );
    _.defer(() => this.form.markAsDirty());
  }

  public markAsPristine(): void {
    this.form.markAsPristine();
  }

  // private
  private setData(data: any = {}): void {
    if (this.form) {
      this.updateForm();
    } else {
      this.createForm();
    }
  }

  private createForm(): void {
    const formControls: any = utils.populateModel(Fitment, this.segmentData, this.data, this);
    formControls.notes = this.fb.array([]);
    this.addNotesFormGroup(formControls.notes);
    this.form = this.fb.group(formControls);
  }

  private updateForm(): void {
    _.each(this.segmentData, (item: any) => {
      if (item.field_map === 'notes') {
        this.form.setControl(item.field_map, new UntypedFormArray([]));
        const formArray: any = this.form.get(item.field_map);
        this.addNotesFormGroup(formArray);
      } else {
        const control = this.form.get(item.field_map);
        if (control) { control.setValue(_.get(this.data, item.item_name, '')); }
      }
    });
    _.defer(() => this.markAsPristine());
  }

  private setPositionLookups(data: any) {
    this.getFieldByMap('position_id').lookup = [
      createOption('', 'Position'),
      ...data
    ];
  }

  private getNotesFormGroup(note: any): UntypedFormGroup {
    const validators = this.getItemValidators(this.getFieldByMap('notes').validation);
    return new UntypedFormGroup({
      'value': new UntypedFormControl(note.value, validators),
      'type_id': new UntypedFormControl(note.type_id),
    });
  }

  private addNotesFormGroup(formArray: UntypedFormArray): void {
    _.each(_.get(this.data, 'assignment_values.notes', [{value: ''}]), (note: any) => {
      formArray.push(this.getNotesFormGroup(note));
    });
  }
}
